import { render, staticRenderFns } from "./AficionVisitanteModal.vue?vue&type=template&id=54898a7d&scoped=true"
import script from "./AficionVisitanteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AficionVisitanteModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AficionVisitanteModal.vue?vue&type=style&index=0&id=54898a7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54898a7d",
  null
  
)

export default component.exports